/** Seconds before a 5xx error toast auto-reloads the page. Shared with the toast countdown UI. */
export const SERVER_ERROR_RELOAD_SECONDS = 8;

/** Returns true when the status code is a client error (400–499). */
export function is4xxClientError(statusCode?: number): boolean {
  return statusCode != null && statusCode >= 400 && statusCode < 500;
}

/** Returns true when the status code is a server error (500+). */
export function is5xxServerError(statusCode?: number): boolean {
  return statusCode != null && statusCode >= 500;
}

/** Reloads the page immediately. */
export function reloadPageNow(): void {
  window.location.reload();
}
